module.exports = __webpack_public_path__ + "img/arrow-up-right-square.f3003c76.svg";